import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import DocumentsSection from '@components/sections/DocumentsSection'

interface Props {
  tenant: LocatairePermanentResponse
  edlList: EtatDesLieuxResponse[]
}

const TenantTopSection = ({ tenant, edlList }: Props) => {
  return (
    <TopSections>
      {/*//TODO: not implmented*/}
      <DocumentsSection
        documents={{ edl: {}, quality: [] }}
        id={tenant.id}
        isManifestation={false}
        edlList={edlList}
        isAlone
      />
    </TopSections>
  )
}

export default TenantTopSection

const TopSections = styled(View)`
  flex-direction: ${(props) => (props.theme.breakpoint === 'big' ? 'row' : 'column')};
  margin-bottom: 16px;
`
